import findIndex from 'lodash/findIndex';
import { EDITOR } from 'constants/actionTypes';
import request from 'utils/request_ajax';
import { getSection } from 'selectors/editor';
import { hideCommentary } from './commentary';

// @TODO write documentation for this file
// @TODO handle errors

// in: payload, out: sections+1
const sectionCreate = payload => ({
  type: EDITOR.SECTION.CREATE,
  payload,
});

// in: id, out: sections-1
const sectionDelete = id => ({
  type: EDITOR.SECTION.DELETE,
  id,
});

// in: payload, out: currentSection
const sectionEdit = payload => ({
  type: EDITOR.SECTION.EDIT,
  payload,
});

const sectionUpdateUrl = url => ({
  type: EDITOR.SECTION.UPDATE_URL,
  url,
});

const setSectionsWithInvalidElements = sectionsWithInvalidElements => ({
  type: EDITOR.LESSON.REFRESH_INVALID_SECTIONS,
  sectionsWithInvalidElements,
});

// in: id+...changes, out: sections
export const sectionUpdate = (id, changes) => ({
  type: EDITOR.SECTION.UPDATE,
  id,
  ...changes,
});

const sectionDuplicate = payload => ({
  type: EDITOR.SECTION.DUPLICATE,
  payload,
});

export const autosaveSuccess = () => ({
  type: EDITOR.AUTOSAVE.SUCCESS,
});

export const autosaveInProgress = () => ({
  type: EDITOR.AUTOSAVE.REQUEST,
});

export const autosaveFail = () => {
  NProgress.done();
  return {
    type: EDITOR.AUTOSAVE.FAILURE,
  };
};

export const sectionOrder = (ownIndex, overIndex) => ({
  type: EDITOR.SECTION.REORDER,
  ownIndex,
  overIndex,
});

export const handleError = (reject, error) => reject(autosaveFail());

export const requestEdit = id => ({
  type: EDITOR.SECTION.REQUEST_EDIT,
  id,
});

export const requestDelete = id => ({
  type: EDITOR.SECTION.REQUEST_DELETE,
  id,
});

export const requestCreate = () => ({
  type: EDITOR.SECTION.REQUEST_CREATE,
});

const sectionActions = {};

sectionActions.requestUpdate = (id, changes) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const { update_path } = getSection(getState().editor, id);
    dispatch(autosaveInProgress());
    request
      .put(update_path, changes)
      .done(data => {
        dispatch(autosaveSuccess());
        dispatch(sectionUpdate(id, changes));
        resolve(data);
      })
      .fail(error => {
        dispatch(autosaveFail());
        reject(error);
      });
  });

sectionActions.requestDuplicate = id => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    NProgress.start();
    const { update_path: updatePath } = getSection(getState().editor, id);
    const duplicatePath = updatePath + '/duplicate';
    dispatch(autosaveInProgress());
    request
      .post(duplicatePath)
      .done(data => {
        dispatch(autosaveSuccess());
        const { sectionsWithInvalidElements } = getState().editor;
        const indexOfSection = sectionsWithInvalidElements.indexOf(id);
        if (indexOfSection !== -1) {
          sectionsWithInvalidElements.push(data.id);
          dispatch(
            setSectionsWithInvalidElements([
              ...sectionsWithInvalidElements,
              data.id,
            ]),
          );
        }

        dispatch(sectionDuplicate(data));
        resolve(data);
        NProgress.done();
      })
      .fail(error => {
        dispatch(autosaveFail());
        reject(error);
      });
  });

sectionActions.fetchElements = id => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    NProgress.start();
    const {
      editor: { commentary, ...editorState },
    } = getState();
    const currentSection = getSection(editorState, id);
    if (currentSection) {
      const { view_path } = currentSection;
      dispatch(requestEdit());
      request
        .get(view_path)
        .done(data => {
          if (commentary.visible) dispatch(hideCommentary());
          resolve(sectionEdit(data));

          if (data.sections_with_invalid_elements) {
            // add the current section to the array, if it is not currently present
            // and dispatch the action.
            dispatch(
              setSectionsWithInvalidElements(
                data.sections_with_invalid_elements,
              ),
            );
          }
          NProgress.done();
        })
        .fail(error => handleError(reject, error));
    } else {
      NProgress.done();
    }
  });

sectionActions.requestNew = elementType => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    NProgress.start();
    dispatch(requestCreate());
    dispatch(autosaveInProgress());
    const { new_section_path, commentary } = getState().editor;
    request
      .post(new_section_path, { element_type: elementType })
      .done(data => {
        if (commentary.visible) dispatch(hideCommentary());
        dispatch(sectionCreate(data));
        resolve(sectionEdit(data));
        dispatch(autosaveSuccess());
        NProgress.done();
      })
      .fail(error => handleError(reject, error));
  });

sectionActions.requestDelete = id => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const { delete_path } = getSection(getState().editor, id);
    NProgress.start();
    dispatch(requestDelete(id));
    dispatch(autosaveInProgress());
    request
      .delete(delete_path)
      .done(data => {
        resolve(sectionDelete(id));

        const { sectionsWithInvalidElements } = getState().editor;

        dispatch(
          setSectionsWithInvalidElements(
            sectionsWithInvalidElements.filter(
              invalidSectionId => invalidSectionId !== id,
            ),
          ),
        );

        dispatch(autosaveSuccess());
        NProgress.done();
      })
      .fail(error => handleError(reject, error));
  });

sectionActions.create =
  (elementType, immediateEdit = true) =>
  (dispatch, getState) => {
    dispatch(sectionActions.requestNew(elementType))
      .then(sectionEditAction => {
        if (immediateEdit) dispatch(sectionEditAction);
        dispatch(sectionUpdateUrl(sectionEditAction.payload.view_path_html));
      })
      .catch(dispatch);
  };

sectionActions.edit =
  (id, shouldUpdateUrl = true) =>
  (dispatch, getState) =>
    dispatch(sectionActions.fetchElements(id))
      .then(action => {
        dispatch(action);
        const { view_path_html } = getSection(getState().editor, id);
        if (shouldUpdateUrl) dispatch(sectionUpdateUrl(view_path_html));
        $('html, body').animate({ scrollTop: '0' }, 300);
      })
      .catch(dispatch);

sectionActions.update = (id, changes) => (dispatch, getState) =>
  dispatch(sectionActions.requestUpdate(id, changes));

sectionActions.duplicate = id => (dispatch, getState) =>
  dispatch(sectionActions.requestDuplicate(id));

sectionActions.delete = id => (dispatch, getState) => {
  const { sections, currentSection } = getState().editor;

  if (sections.length > 1 && currentSection.id === id) {
    const index = findIndex(sections, { id });
    const sibling = sections[index + 1] || sections[index - 1];
    return Promise.all([
      dispatch(sectionActions.fetchElements(sibling.id)),
      dispatch(sectionActions.requestDelete(id)),
    ])
      .then(actions => {
        actions.forEach(dispatch);
        dispatch(sectionUpdateUrl(sibling.view_path_html));
      })
      .catch(dispatch);
  }

  return dispatch(sectionActions.requestDelete(id))
    .then(dispatch) // => sectionDelete
    .catch(dispatch);
};

export default sectionActions;
